import React from "react";
import Layout from "../components/Layout/Layout";
import Container from "../components/Container/Container";
import BottomNav from "../components/BottomNav/BottomNav";
import Card from "../components/Card/Card";
import gitprojects from "../../projects";

const classes = require("../../styles/PageStyles/projects.module.scss");

const projects = (props: { location: any }) => {
    const webdevProjects = gitprojects
        .filter(project => project.type === "webdev")
        .map(singleProj => {
            return (
                <Card
                    title={singleProj.title}
                    description={singleProj.description}
                    link={singleProj.link}
                    techUsed={singleProj.tech}
                />
            );
        });

    const dataProjects = gitprojects
        .filter(project => project.type === "data")
        .map(singleProj => {
            return (
                <Card
                    title={singleProj.title}
                    description={singleProj.description}
                    techUsed={singleProj.tech}
                    link={singleProj.link}
                />
            );
        });

    return (
        <Layout>
            <Container direction="column">
                <h1 className={classes.projectsPageHeading}>
                    Projects and Articles
                </h1>
                <h3>Web Dev</h3>
                <div className={classes.cardContainment}>
                    <div className={classes.cards}>
                        {/* Cards go in here */}
                        {webdevProjects}
                    </div>
                    <p className={classes.biggerScreenMessage}>
                        Since I'm Continually Deploying this site, This feature
                        is currently available on mobile!
                    </p>
                </div>
                <h3>Data</h3>
                <div className={classes.cardContainment}>
                    <div className={classes.cards}>
                        {/* Cards go in here */}
                        {dataProjects}
                    </div>
                    <p className={classes.biggerScreenMessage}>
                        Since I'm Continually Deploying this site, This feature
                        is currently only available on mobile!
                    </p>
                </div>
                <h3>Articles</h3>
                <div className={classes.cardContainment}>
                    <p>Articles will be written soon!</p>
                    <p className={classes.biggerScreenMessage}>
                        Since I'm Continually Deploying this site, This feature
                        is currently only available on mobile!
                    </p>
                </div>
                {/* Bottom Nav */}
                <BottomNav location={props.location} />
            </Container>
        </Layout>
    );
};

export default projects;
